var map = {
	"./answers/hexagons_1.png": [
		6960
	],
	"./answers/hexagons_2.png": [
		5291
	],
	"./answers/hexagons_3.png": [
		7426
	],
	"./answers/hexagons_4.png": [
		9933
	],
	"./answers/hexagons_5.png": [
		3636
	],
	"./axa_logo.svg": [
		4729
	],
	"./background.png": [
		3495,
		495
	],
	"./bio-biene.png": [
		5237,
		237
	],
	"./default.png": [
		1836,
		836
	],
	"./flora_futura.svg": [
		2775,
		775
	],
	"./fun-fact.png": [
		8437
	],
	"./habitat-hase.png": [
		9868,
		868
	],
	"./oeko-otter.png": [
		6296,
		296
	],
	"./share.svg": [
		6060
	],
	"./stadt-streuner.png": [
		4966,
		966
	],
	"./umwelt-uhu.png": [
		9934,
		934
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4161;
module.exports = webpackAsyncContext;